import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { apiClient } from '../api/ApiClient';

const ContactUsComponent = () => {
  const navigate = useNavigate();
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  
  useEffect(() => {
    fetchSubjects();
  }, []);

  const fetchSubjects = async () => {
    try {
      const response = await apiClient.get('/rest/connections/subjects');
      const formattedSubjects = response.data.map(subject => ({
        code: subject[0],
        description: subject[1]
      }));
      setSubjects(formattedSubjects);
    } catch (error) {
      setError("Failed to load subjects. Please try again later.");
      console.error('Error fetching subjects:', error);
    } finally {
      setLoading(false);
    }
  };


// In your handleSendEmail function:
const handleSendEmail = async () => {
  if (!selectedSubject || !message.trim()) {
    setError('Please fill in all fields');
    return;
  }

  setSending(true);
  setError("");

  // Remove the nested contactMail object
  const requestData = {
    message: [
      {
        name: 'subject_code',
        val: selectedSubject
      },
      {
        name: 'subject_desc',
        val: subjects.find(s => s.code === selectedSubject)?.description || ''
      },
      {
        name: 'contact_body',
        val: message.trim()
      }
    ]
  };

  try {
    const response = await apiClient.post('/rest/connections/contactus', requestData);
    if (response.data && response.data.length > 0) {
      setSuccess(true);
      setTimeout(() => {
        navigate('/search');
      }, 900);
    }
  } catch (error) {
    setError(error.response?.data?.message || 'Failed to send message. Please try again.');
    console.error('Error sending email:', error);
  } finally {
    setSending(false);
  }
};




  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <div className="container-1024">
      <div className="results-area">
        <h3>Contact Us</h3>
        <Card>
          <Card.Body>
            {error && (
              <Alert variant="danger" onClose={() => setError("")} dismissible>
                {error}
              </Alert>
            )}
            {success && (
              <Alert variant="success">
                Message sent successfully! Redirecting...
              </Alert>
            )}
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Subject <span className="text-danger">*</span></Form.Label>
                <Form.Select 
                  value={selectedSubject}
                  onChange={(e) => setSelectedSubject(e.target.value)}
                  isInvalid={!!error && !selectedSubject}
                >
                  <option value="">Select a subject</option>
                  {subjects.map((subject) => (
                    <option key={subject.code} value={subject.code}>
                      {subject.description}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Message <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  as="textarea"
                  rows={6}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Type your message here..."
                  maxLength={2000}
                  isInvalid={!!error && !message.trim()}
                />
                <Form.Text className="text-muted">
                  {message.length}/2000 characters
                </Form.Text>
              </Form.Group>

              <div className="d-flex justify-content-end gap-2">
                <Button 
                  variant="secondary" 
                  onClick={() => navigate(-1)}
                  disabled={sending}
                >
                  Cancel
                </Button>
                <Button 
                  variant="primary" 
                  onClick={handleSendEmail}
                  disabled={sending || !selectedSubject || !message.trim()}
                >
                  {sending ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Sending...
                    </>
                  ) : (
                    'Send Message'
                  )}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default ContactUsComponent;